// Ask Horizon to search Wisconsin's franchise registry for an FDD by brand name, regardless of
// whether that brand exists in Command Center yet. The response only confirms the search was
// queued, not that it found anything: SearchForBrandFddOnHorizonJob waits on Horizon and imports
// the FDD if one turns up, which takes minutes. Nothing here polls for that, so the Brand/FDD
// appears on a later page load rather than in this modal.
$(document).on('click', '#horizon-fdd-search-submit', function () {
  const $button = $(this);
  const $input = $('#horizon_fdd_search_brand_name');
  const $result = $('#horizon-fdd-search-result');
  const brandName = $input.val().trim();

  $result.empty();

  if (!brandName) {
    $result.html('<div class="text-danger">Please enter a brand name.</div>');
    return;
  }

  $button.prop('disabled', true);

  $.post('/non_inventory_brands/search_for_fdd', { brand_name: brandName }).done(function (data) {
    if (data.success) {
      $result.html('<div class="text-success">' + data.message + '</div>');
      return;
    }

    $result.html('<div class="text-danger">' + data.errors + '</div>');
  }).fail(function (jqXHR) {
    const message = (jqXHR.responseJSON && jqXHR.responseJSON.errors) || 'Something went wrong.';
    $result.html('<div class="text-danger">' + message + '</div>');
  }).always(function () {
    $button.prop('disabled', false);
  });
});

// Reset the modal's input/result whenever it's closed, so the next open starts fresh.
$(document).on('hidden.bs.modal', '#horizon-fdd-search-modal', function () {
  $('#horizon_fdd_search_brand_name').val('');
  $('#horizon-fdd-search-result').empty();
});
